import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {invoice, invoices,invoiceDeadline, invoiceStats,invoiceBook ,attendeeInvoices ,attendeeInvoice,attendeeInvoiceExp ,attendeeInvoiceInfo} = api



/**
 * 查找发票
 */
export async function findInvoice(params) {
    return request({url: invoice, method: 'get', data: params,})
}
/**
 * 查找发票
 */
export async function findAttendeeInvoiceInfo(params) {
    return request({url: attendeeInvoiceInfo, method: 'get', data: params,})
}

/**
 * 统计
 */
export async function findUserInvoiceStats(params) {
    return request({url: invoiceStats, method: 'get', data: params,})
}

/**
 * 创建发票
 */
export async function createInvoice(params) {
    return request({url: invoices, method: 'post', data: params,})
}

export async function createInvoiceByDeadline(params) {
    return request({url: invoiceDeadline, method: 'post', data: params,})
}

/**
 * 更新发票
 */
export async function updateInvoice(params) {
    return request({url: invoice, method: 'put', data: params,})
}

/**
 * 删除发票
 */
export async function deleteInvoice(params) {
    return request({url: invoice, method: 'delete', data: params,})
}


/**
 * 查找发票列表
 */
export async function findInvoices(params) {
    return request({url: invoices, method: 'get', data: params,})
}

/**
 * 删除发票
 */
export async function deleteInvoices(params) {
    return request({url: invoices, method: 'delete', data: params,})
}

/**
 * 查找
 */
export async function findInvoiceBook(params) {
    return request({url: invoiceBook, method: 'get', data: params,})
}
/**
 * 编辑
 */
export async function updateInvoiceBook(params) {
    return request({url: invoiceBook, method: 'put', data: params,})
}
/**
 * 查找
 */
export async function findAttendeeInvoices(params) {
    return request({url: attendeeInvoices, method: 'get', data: params,})
}
/**
 * 申请
 */
export async function createAttendeeInvoices(params) {
    return request({url: attendeeInvoices, method: 'post', data: params,})
}
/**
 * 更新
 */
export async function updateAttendeeInvoice(params) {
    return request({url: attendeeInvoice, method: 'put', data: params,})
}
/**
 * 删除
 */
export async function deleteAttendeeInvoice(params) {
    return request({url: attendeeInvoice, method: 'delete', data: params,})
}
/**
 * 导出
 */
export async function expAttendeeInvoice(params) {
    return request({url: attendeeInvoiceExp, method: 'get', data: params,})
}



// WEBPACK FOOTER //
// ./src/services/invoice.js